import React, { Component } from 'react';  
import { BrowserRouter as Router,Routes, Route } from 'react-router-dom';  

import './App.css';
import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';
import Home from './components/layout/Home';
import SearchServiceRecords from './components/service-records/SearchServiceRecords';
import Contact from './components/layout/Contact';

class App extends Component {  
  render() {  
    return (  
       <Router>  
           <div className="page">  
          <header>
            <Navbar/>
          </header>
            <section id="main">           
              <Routes>  
                      <Route exact path='/' element={<Home/>}></Route>  
                      <Route exact path='/index.html' element={<Home/>}></Route>  
                      <Route exact path='/search' element={<SearchServiceRecords/>}></Route> 
                      <Route exact path='/search.html' element={<SearchServiceRecords/>}></Route> 
                      <Route exact path='/contact' element={ <Contact/>}></Route>
                      <Route exact path='/contact.html' element={<Contact/>}></Route> 
              </Routes>  
            </section>
            <Footer/>
          </div>  
       </Router>  
   );  
  }  
}  
export default App;  